import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {Link} from 'react-router-dom';
import {ContactSupport} from '../../components';
import {Routes} from '../../Routes';

export function TestOrderUnavailable() {
    const intl = useIntl();

    return (
        <div className={'grid fifty-fifty center-content test-order-unavailable'}>
            <div className={'left'}>
                <h1 data-test-id={'test-order-unavailable-title'}>
                    <FormattedMessage id={'testOrderUnavailable.title'} />
                </h1>
                <p>
                    <FormattedMessage id={'testOrderUnavailable.description'} />
                </p>
                <p>
                    <FormattedMessage
                        id={'testOrderUnavailable.contactSupport'}
                        values={{
                            cs: (chunk) => (
                                <ContactSupport
                                    className={'active'}
                                    dataTestId={'contact-support-link'}
                                    text={chunk}
                                />
                            ),
                        }}
                    />
                </p>
                <p>
                    <Link
                        className={'link active'}
                        data-test-id={'logout-link'}
                        title={intl.formatMessage({id: 'common.logOut.title'})}
                        to={Routes.LOGOUT}
                    >
                        <FormattedMessage id={'common.logOut.text'} />
                    </Link>
                </p>
            </div>
            <img
                alt={''}
                className={'right'}
                role={'presentation'}
                src={'/images/square-and-circle.svg'}
            />
        </div>
    );
}
